import { Check1 } from '../streamlineSolidIcon/Check1';
import { StandardButton, type StandardButtonProps } from './StandardButton';

interface Props extends Omit<StandardButtonProps, 'startIcon' | 'endIcon'> {}

export const SaveButton = ({ size, text, color, ...props }: Props) => (
  <StandardButton
    variant="contained"
    color={color || 'primary'}
    text={text || 'Save'}
    startIcon={<Check1 />}
    size={size}
    {...props}
  />
);
